import { useBoxStyle } from "arkh";
import React from "react";
import { WidgetEmployeeLeaveSettingsStack } from "./WidgetEmployeeLeaveSettingsStack";
import { WidgetEmployeeLeaveSettingsMain } from "./WidgetEmployeeLeaveSettingsMain";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { WidgetEmployeeLeaveSettingsTeams } from "./WidgetEmployeeLeaveSettingsTeams";
import { WidgetEmployeeLeaveSettingsLeaveReasons } from "./WidgetEmployeeLeaveSettingsLeaveReasons";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";

export function WidgetEmployeeLeaveSettingsNavigator(props: {
  onCancel(): void;
}) {
  const contentStyle = useBoxStyle({ color: "surface-background-light" });
  const intl_tokens = useIntlTokens();
  const getHeaderOptions = useNavigationHeaderOptions();
  return (
    <WidgetEmployeeLeaveSettingsStack.Navigator
      screenOptions={{
        contentStyle,
      }}
      initialRouteName="WELSMain"
    >
      <WidgetEmployeeLeaveSettingsStack.Screen
        name="WELSMain"
        component={WidgetEmployeeLeaveSettingsMain}
        options={{
          ...getHeaderOptions({
            title: intl_tokens.Absence,
            type: "SAVE-INIT",
            onCancel: props.onCancel,
            defaultContentStyle: true,
          }),
        }}
      />
      <WidgetEmployeeLeaveSettingsStack.Screen
        name="WELSTeams"
        component={WidgetEmployeeLeaveSettingsTeams}
        options={({ navigation }) => ({
          ...getHeaderOptions({
            type: "DONE",
            title: intl_tokens.Teams,
            onDone: () => {
              navigation.goBack();
            },
            defaultContentStyle: true,
          }),
        })}
      />

      <WidgetEmployeeLeaveSettingsStack.Screen
        name="WELSLeaveReasons"
        component={WidgetEmployeeLeaveSettingsLeaveReasons}
        options={({ navigation }) => ({
          ...getHeaderOptions({
            type: "DONE",
            title: intl_tokens.ReasonsForAbsence,
            onDone: () => {
              navigation.goBack();
            },
            defaultContentStyle: true,
          }),
        })}
      />
    </WidgetEmployeeLeaveSettingsStack.Navigator>
  );
}
